import { render } from "./RightPanel.vue?vue&type=template&id=ecab5668&scoped=true"
import script from "./RightPanel.vue?vue&type=script&lang=js"
export * from "./RightPanel.vue?vue&type=script&lang=js"

import "./RightPanel.vue?vue&type=style&index=0&id=ecab5668&scoped=true&lang=css"

import exportComponent from "/home/q4-cockpitmdwareorg/q4-cockpit.mdware.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ecab5668"]])

export default __exports__